document.addEventListener("DOMContentLoaded", () => {
    const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
    if (!isDesktop) return;
    
    const zigzags = document.querySelectorAll("[data-zigzag]");

    zigzags.forEach((el, index) => {
        const element = el;
        const img = element.querySelector(".img-block");
        
        if (!img) return;

        const isImageLeft = element.classList.contains('is-image-left');
        const slideDistance = 30; // Desplazamiento sutil
        const initialX = isImageLeft ? -slideDistance : slideDistance;

        gsap.set(img, { 
            opacity: 0, 
            x: initialX
        });

        gsap.to(img, {
            opacity: 1,
            x: 0,
            duration: 0.8,
            ease: "power2.out",
            scrollTrigger: {
                trigger: element,
                start: "top 80%",
                toggleActions: "play none none reverse"
            }
        });
    });
});
